// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as UserRoleRepoConfig from "./UserRoleRepoConfig.bs.js";

var dummyUserRoleResponse = {
        "role": "business_admin",
        "admin_info": {
          "email": "test@xyz.com",
          "first_name": "test",
          "last_name": "test"
        }
      };

function fetchUserDetails(_country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyUserRoleResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(UserRoleRepoConfig.UserRoleResponseConverter.execute, result);
                        });
            });
}

var UserRoleRepo = {
  fetchUserDetails: fetchUserDetails
};

export {
  UserRoleRepo ,
  
}
/* UserRoleRepoConfig Not a pure module */
